import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "history",
  "use": "history-usage",
  "viewBox": "0 0 15 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 18\" id=\"history\"><text font-weight=\"bold\" font-family=\"Helvetica, Arial, sans-serif\" font-size=\"18\" y=\"15\" x=\"1\" stroke-width=\"0\" stroke=\"#000\" fill=\"#fff\">H</text></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/svg/history.svg
// module id = 1549
// module chunks = 0